export const getSpotifyEmbedUrl = (value?: string | null): string | null => {
  const input = value?.trim();
  if (!input) return null;

  // Preserve playlist IDs already accepted by the CMS.
  if (/^[a-zA-Z0-9]{22}$/.test(input)) {
    return `https://open.spotify.com/embed/playlist/${input}`;
  }

  try {
    const url = new URL(input);
    if (
      url.origin !== "https://open.spotify.com" &&
      url.origin !== "http://open.spotify.com"
    ) return null;

    const match =
      url.pathname.match(
        /^\/(?:intl-[a-z]{2}\/)?(?:embed\/)?(playlist|album)\/([a-zA-Z0-9]{22})\/?$/
      ) ||
      url.pathname.match(
        /^\/(?:intl-[a-z]{2}\/)?(?:embed\/)?user\/[^/]+\/(playlist)\/([a-zA-Z0-9]{22})\/?$/
      );
    return match
      ? `https://open.spotify.com/embed/${match[1]}/${match[2]}`
      : null;
  } catch {
    return null;
  }
};

export default getSpotifyEmbedUrl;
